import BaseModal from "./BaseModal";
import ButtonGroup from "../Buttons/ButtonGroup";
import ErrorButton from "../Buttons/ErrorButton";
import FieldInput from "../Form/Fields/FieldInput";
import FieldPassword from "../Form/Fields/FieldPassword";
import MediaQueryContextProvider from "../../Context/MediaQueryContext";
import React, { useContext } from "react";
import SubmitButton from "../Buttons/SubmitButton";
import translate from "../../Utils/translate";

const ViewPasswordModal = ({ activeAccount, handleCloseModal, handleUpdate }) => {
  const { isDesktop } = useContext(MediaQueryContextProvider);

  if (!activeAccount?.password) {
    return null;
  }

  function getForm() {
    return (
      <div className="flex flex-col h-full">
        <div className="flex-grow [&>*]:mb-default last:mb-0 ">
          <div className="flex items-center">
            <img
              src={activeAccount.icon}
              alt={`Icon for ${activeAccount.appName}`}
              className="h-8 w-8 rounded-2xl mr-default"
            />
            <h1 className="font-bold text-medium">{`${activeAccount?.appName} | ${activeAccount?.tags[0]}`}</h1>
          </div>
          <FieldInput copy={true} value={activeAccount?.username} name="username" readOnly={true} />
          <FieldPassword copy={true} value={activeAccount?.password} name="password" readOnly={true} />
        </div>

        <ButtonGroup>
          <ErrorButton text={translate("forms.buttons.cancel")} type="button" onClick={handleCloseModal} />
          <SubmitButton text={translate("forms.buttons.edit")} type="submit" onClick={handleUpdate} />
        </ButtonGroup>
      </div>
    );
  }
  return isDesktop ? getForm() : <BaseModal handleCloseModal={handleCloseModal}>{getForm()} </BaseModal>;
};

export default ViewPasswordModal;
